import React from "react";
import { NursingQuestionPossibleAnswer } from "../../../../../../messages/VBP";
import { AppRadio } from "../../../../../Generic/AppRadio";

export interface Props {
  selectedValue: string | null;
  possibleAnswers: NursingQuestionPossibleAnswer[];
  onQuestionClick: (answer: NursingQuestionPossibleAnswer) => void;
}

const VBPRadioQuestion = (props: Props) => {
  return (
    <div className="VBPRadioQuestion">
      {props.possibleAnswers.map((possibleAnswer: NursingQuestionPossibleAnswer, index: number) => {
        return (
          <AppRadio
            key={index}
            value={possibleAnswer.text}
            isChecked={props.selectedValue === possibleAnswer.text}
            onChange={() => {
              props.onQuestionClick(possibleAnswer);
            }}
          />
        );
      })}
    </div>
  );
};

export default React.memo(VBPRadioQuestion);
